import { formatDateToMMDDYY } from '../../utils/utils';

export const EditInvoiceDefaultValue = data => {
  return {
    grand_total: `$ ${data?.grand_total}`,
    revised_date: formatDateToMMDDYY(data?.revised_date || null),
    invoice_details: data?.invoice_details || [{}],
  };
};

export default EditInvoiceDefaultValue;
